export const ScrollSection = {
  SUB_INPUT: 'sub_input',
  IMAGE: 'image',
  FARM: 'farm',
  CULTIVATION: 'cultivation',

  INPUT_UNIT: 'input_unit',

  TITLE: 'title',
  DESCRIPTION: 'description',
  NAME: 'name',

  QUANTITY_PACK: 'quantity_pack',
  AVAILABLE_QUANTITY: 'available_quantity',
  MIN_SELL_QUANTITY: 'min_sell_quantity',

  AD_PRICE: 'ad_price',
  DISCOUNT: 'discount',

  LOCATION: 'location',
} as const;

export const errorScrollSections = {
  // --------------------------
  // Category / Type
  // --------------------------
  sub_input: ScrollSection.SUB_INPUT,

  // --------------------------
  // Farm
  // --------------------------
  farm: ScrollSection.FARM,

  // --------------------------
  // Cultivation
  // --------------------------
  cultivation: ScrollSection.CULTIVATION,

  // --------------------------
  // Quantity / Units
  // --------------------------
  wanted_weight: ScrollSection.INPUT_UNIT,
  wanted_number: ScrollSection.INPUT_UNIT,
  area: ScrollSection.INPUT_UNIT,

  quantity_pack: ScrollSection.QUANTITY_PACK,
  quantity_pack_unit: ScrollSection.QUANTITY_PACK,

  weight_unit: ScrollSection.INPUT_UNIT,
  price_unit: ScrollSection.AD_PRICE,

  renting_duration: ScrollSection.INPUT_UNIT,
  renting_duration_unit: ScrollSection.INPUT_UNIT,
  employing_duration_unit: ScrollSection.INPUT_UNIT,

  requirement_during: ScrollSection.INPUT_UNIT,
  employing_duration: ScrollSection.INPUT_UNIT,

  // --------------------------
  // Text fields
  // --------------------------
  title: ScrollSection.TITLE,
  description: ScrollSection.DESCRIPTION,
  name: ScrollSection.NAME,

  // --------------------------
  // Sale quantities
  // --------------------------
  available_quantity: ScrollSection.AVAILABLE_QUANTITY,
  min_sell_quantity: ScrollSection.MIN_SELL_QUANTITY,

  // --------------------------
  // Price
  // --------------------------
  ad_price: ScrollSection.AD_PRICE,
  negotiated_price: ScrollSection.AD_PRICE,

  // --------------------------
  // Discount
  // --------------------------
  discount_amount: ScrollSection.DISCOUNT,
  has_discount: ScrollSection.DISCOUNT,

  // --------------------------
  // Images
  // --------------------------
  selectedMainImg: ScrollSection.IMAGE,

  // --------------------------
  // Location
  // --------------------------
  location: ScrollSection.LOCATION,
  lat: ScrollSection.LOCATION,
  lng: ScrollSection.LOCATION,
} satisfies Record<string, string>;
